export const BannerTiming = {
  /** Total time the initial "offline" message shows before transitioning to grey */
  TRANSITION_MS: 1800,

  /** Duration of slide-in/slide-out animations - must match --offline-banner-slide-duration in SCSS */
  EXIT_ANIMATION_MS: 300,

  /** Time the "online" message displays before starting exit animation (TRANSITION_MS - EXIT_ANIMATION_MS) */
  get ONLINE_MESSAGE_MS(): number {
    return this.TRANSITION_MS - this.EXIT_ANIMATION_MS;
  },
} as const;

export const BannerTranslationKeys = {
  OFFLINE: 'connectivity.offline',
  ONLINE: 'connectivity.online',
} as const;
